module.exports = __webpack_public_path__ + "img/Logo.97852107.png";